import { getToken } from "./tokenStore";

const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
const baseApi7Url = process.env.REACT_APP_BASE_API_7_URL;
const VERSION_CHECK_CLIENTS_API = process.env.REACT_APP_VERSION_CHECK_CLIENTS;

export async function exchangeToken(authID, version) {
  let res = await fetch(`${AUTH_API_URL}/${version}/OpenApiauth/ExchangeOAuth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token: authID }),
  });

  if (res.status === 200) {
    let data = await res.json();
    return data;
  } else {
    let name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
  // else throw res;
}

export async function validateToken(version) {
  const token = getToken();
  let res = await fetch(`${AUTH_API_URL}/${version}/OpenApiauth/ValidateToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  let data = await res.json();

  if (data.statusCode !== 200) {
    let name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise((resolve) => setTimeout(resolve, 500));
    return false;
  }

  return true;
}
export async function refreshToken(token, refAuthID, version) {
  const res = await fetch(`${AUTH_API_URL}/${version}/OpenApiauth/RefreshToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ refAuthID }),
  });

  const data = await res.json();
  if (data.statusCode === 200) {
    return {
      token: data.token,
      minutesToExpire: data.minutesToExpire,
      refAuthID: data.refAuth,
    };
  }
  let name = "sessionout";
  window.parent.postMessage(name, "*");
  await new Promise((resolve) => setTimeout(resolve, 500));
  return null;
}

export async function getCorporations(urlInfo) {
  const token = getToken();

  let res = await fetch(`${baseApi7Url}/corporations?IsShowAll=false`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return res.json();
}
export async function getpreference(urlInfo) {
  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetLegalNameorDbName`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return res.json();
}

export async function getPCS(corporationID, urlInfo) {
  const token = getToken();

  let res = await fetch(`${baseApi7Url}/pcs?CorpID=${corporationID}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  let data = await res.json();
  return data["ListInfo"];
}

export async function v2Clients() {
  const token = getToken();
  const response = await fetch(`${VERSION_CHECK_CLIENTS_API}/v2_clients`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Request failed");
  }
  const data = await response.json();

  return data;
}
